module.exports = __webpack_public_path__ + "img/ico_prancheta-medica.8950968b.svg";